import { FindifyDataContextType } from "@/contexts/FindifyDataContext";

export const getTranslatedString = (string: any, findifyDataContext: FindifyDataContextType) => {
    if (string) {

        if (typeof string === 'string') {
            return string;
        }
        const language = findifyDataContext.language;
        if (string[language]) {
            return string[language];
        } else if (string['en-GB']) {
            return string['en-GB'];

        }
        else {
            const stringLangs = Object.keys(string);
            if (string[stringLangs[0]]) {
                return string[stringLangs[0]];
            }
        }
    }
    return '';
}